export const topHotelByTravelerType = [
  {
    city_name: 'Dubai',
    city_code: 'DXB',
    traveler_types: {
      SOLO: [85205, 2930245, 1656204, 2895652],
      BUSINESS: [85205, 2930245, 1656204, 2923172],
      FAMILY: [85205, 1656204, 2876961, 767334],
      COUPLE: [85205, 1656204, 2923172, 2158796],
    },
  },
  {
    city_name: 'Makkah',
    city_code: '8283',
    traveler_types: {
      SOLO: [1253539, 3420063, 1985111, 708824],
      BUSINESS: [1253539, 3420063, 1985111, 708824],
      FAMILY: [3420063, 1985111, 678880, 454345],
      COUPLE: [2930551, 2930639, 131932, 678874],
    },
  },
  {
    city_name: 'Doha',
    city_code: 'DOH',
    traveler_types: {
      SOLO: [711642, 1112625, 79509, 900489],
      BUSINESS: [711642, 1112625, 79509, 900489],
      FAMILY: [711642, 1112625, 79509, 900489],
      COUPLE: [711642, 1112625, 79509, 900489],
    },
  },
  {
    city_name: 'Al Madinah',
    city_code: 'MED',
    traveler_types: {
      SOLO: [1028508, 652336, 2930700, 166306],
      BUSINESS: [1028508, 652336, 166306, 2930640],
      FAMILY: [1028508, 652336, 166297, 166306],
      COUPLE: [2930700, 2930265, 1758959, 1028508],
    },
  },
  {
    city_name: 'Cairo',
    city_code: 'CAI',
    traveler_types: {
      SOLO: [52655, 52676, 3428966, 52525],
      BUSINESS: [52655, 52676, 3428966, 52525],
      FAMILY: [52655, 52676, 52525, 1010305],
      COUPLE: [52655, 52676, 2157591, 52505],
    },
  },
  {
    city_name: 'Istanbul',
    city_code: 'IST',
    traveler_types: {
      SOLO: [2159419, 129519, 809766, 128854],
      BUSINESS: [2159419, 129519, 809766, 128854],
      FAMILY: [2159419, 129519, 809766, 128854],
      COUPLE: [2159419, 129519, 809766, 128854],
    },
  },
  {
    city_name: 'Riyadh',
    city_code: 'RUH',
    traveler_types: {
      SOLO: [2157512, 926288, 244256, 2149276],
      BUSINESS: [2157512, 926288, 2149276, 244256],
      FAMILY: [1041439, 2157512, 926288, 244256],
      COUPLE: [2146717, 2183435, 756846, 882299],
    },
  },
  {
    city_name: 'Manama',
    city_code: 'BAH',
    traveler_types: {
      SOLO: [2921404, 458414, 2921362, 2931682],
      BUSINESS: [2921404, 458414, 2921362, 2931682],
      FAMILY: [458414, 458228, 3425469, 2146731],
      COUPLE: [2921404, 458414, 2921362, 2931682],
    },
  },
  {
    city_name: 'Jeddah',
    city_code: 'JED',
    traveler_types: {
      SOLO: [2148362, 1580855, 949451, 131955],
      BUSINESS: [2148362, 1580855, 949451, 131955],
      FAMILY: [1266596, 1656226, 131905, 131906],
      COUPLE: [2930639, 1353477, 131950, 131955],
    },
  },
  {
    city_name: 'London',
    city_code: 'LON',
    traveler_types: {
      SOLO: [2908041, 153542, 153822, 412696],
      BUSINESS: [2908041, 153542, 153822, 412696],
      FAMILY: [2908041, 153542, 412696, 155030],
      COUPLE: [2150970, 2894309, 1654301, 154697],
    },
  },
  {
    city_name: 'Abu Dhabi',
    city_code: 'AUH',
    traveler_types: {
      SOLO: [1754365, 2931436, 19805, 19774],
      BUSINESS: [1754365, 2931436, 19805, 19774],
      FAMILY: [1754365, 2931436, 19805, 19774],
      COUPLE: [1754365, 2931436, 19774, 2146783],
    },
  },
  {
    city_name: 'Phuket',
    city_code: 'HKT',
    traveler_types: {
      SOLO: [117412, 117815, 2159774, 2159747],
      BUSINESS: [117412, 117815, 2159774, 2159747],
      FAMILY: [117412, 117815, 2159774, 2159747],
      COUPLE: [117412, 117815, 2159774, 895151],
    },
  },
  {
    city_name: 'Bangkok',
    city_code: 'BKK',
    traveler_types: {
      SOLO: [1386902, 35532, 681521, 35116],
      BUSINESS: [1386902, 35532, 681521, 35116],
      FAMILY: [35532, 681521, 35479, 35026],
      COUPLE: [1386902, 1524292, 34645, 1045294],
    },
  },
  {
    city_name: 'Kuwait',
    city_code: 'KWI',
    traveler_types: {
      SOLO: [708667, 97422, 1964062, 2921911],
      BUSINESS: [708667, 97422, 1964062, 2921911],
      FAMILY: [432700, 708667, 142288, 699834],
      COUPLE: [708667, 97422, 2921911, 699834],
    },
  },
  {
    city_name: 'Sharjah',
    city_code: 'SHJ',
    traveler_types: {
      SOLO: [952324, 1855737, 2809200, 2148154],
      BUSINESS: [1855737, 952324, 653723, 947119],
      FAMILY: [1855737, 2148154, 2157761, 256904],
      COUPLE: [1855737, 2809200, 2148154, 2147450],
    },
  },
  {
    city_name: 'Goa',
    city_code: 'GOI',
    traveler_types: {
      SOLO: [3356957, 1031990, 104933, 2963172],
      BUSINESS: [1031990, 2963172, 105055, 1436998],
      FAMILY: [1031990, 104933, 105055, 1031851],
      COUPLE: [3356957, 1031990, 2963172, 105055],
    },
  },
  {
    city_name: 'Sharm El Sheikh',
    city_code: 'SSH',
    traveler_types: {
      SOLO: [779936, 3206012, 1042529, 817513],
      BUSINESS: [779936, 3206012, 1042529, 817513],
      FAMILY: [779936, 3206012, 1042529, 817513],
      COUPLE: [779936, 3206012, 1042529, 817513],
    },
  },
  {
    city_name: 'Kuala Lumpur',
    city_code: 'KUL',
    traveler_types: {
      SOLO: [2678883, 42679, 141488, 2593083],
      BUSINESS: [2678883, 42679, 141488, 141455],
      FAMILY: [42679, 141488, 141512, 141425],
      COUPLE: [42679, 141488, 141455, 141425],
    },
  },
  {
    city_name: 'Muscat',
    city_code: 'MCT',
    traveler_types: {
      SOLO: [164787, 164808, 2289724, 2288670],
      BUSINESS: [164787, 164808, 2289724, 2288670],
      FAMILY: [164787, 692903, 7936, 164793],
      COUPLE: [164808, 2289724, 692903, 7936],
    },
  },
  {
    city_name: 'Singapore',
    city_code: 'SIN',
    traveler_types: {
      SOLO: [1298034, 258101, 257940, 257975],
      BUSINESS: [3034891, 258101, 258013, 257940],
      FAMILY: [258101, 258013, 257940, 258111],
      COUPLE: [258101, 258013, 821421, 258278],
    },
  },
];
